export enum BatchPaymentCategory {
  CashPass = 'CASH-PASS', // 캐시패스VIP
  GAtu = 'G-ATU', // 구글 ATU
}
